export default {"src":"/_next/static/media/Scaler-logo.3a1ada3f.svg","height":120,"width":887,"blurWidth":0,"blurHeight":0};